
  const lineClampClass = "line-clamp-2"

  export default {
    showMore: true,

    bindOnce(toClamp, link) {
      if (this.el.dataset.lineClampBound === "true") return

      this.link = link
      this.onLinkClick = () => {
        const showLessText = this.el.dataset.showLessText
        const showMoreText = this.el.dataset.showMoreText

        if (this.showMore) {
          link.innerText = showLessText
        } else {
          link.innerText = showMoreText
        }

        toClamp.classList.toggle(lineClampClass)
        this.showMore = !this.showMore
      }
      link.addEventListener("click", this.onLinkClick)

      this.el.dataset.lineClampBound = "true"
    },

    setup() {
      const showLessText = this.el.dataset.showLessText
      const showMoreText = this.el.dataset.showMoreText

      const toClamp = this.el.querySelector("div")
      const link = toClamp.parentElement.querySelector(".action--show-more")

      if (!link) {
        console.warn("Element a.action--show-more not found within", this.el)
        return
      }

      // Always measure with the clamp applied — otherwise an updated()
      // firing while the user has the content expanded would compare
      // the natural height to itself and conclude there's no overflow,
      // killing the "Show less" link.
      toClamp.classList.add(lineClampClass)
      const overflowing = toClamp.scrollHeight != toClamp.clientHeight

      if (overflowing) {
        if (!this.showMore) toClamp.classList.remove(lineClampClass)
        link.classList.remove("hidden")
        link.innerText = this.showMore ? showMoreText : showLessText
        this.bindOnce(toClamp, link)
      } else {
        // Content no longer overflows. Hide the link, drop the clamp,
        // and reset state so a future overflow starts clamped.
        link.classList.add("hidden")
        toClamp.classList.remove(lineClampClass)
        this.showMore = true
      }
    },

    mounted() {
      this.setup()

      // When rendered inside a hidden tab/modal, mounted() measures a
      // 0×0 element and concludes "not overflowing". Re-measure once
      // the element actually becomes visible.
      this.visibilityObserver = new IntersectionObserver(
        (entries) => entries.forEach((entry) => {
          if (entry.isIntersecting) this.setup()
        }),
        { threshold: 0 }
      )
      this.visibilityObserver.observe(this.el)
    },

    updated() {
      this.setup()
    },

    destroyed() {
      this.visibilityObserver?.disconnect()
      this.link?.removeEventListener("click", this.onLinkClick)
    }
  }
